import { useState, useEffect } from "react";
import Banner from './Banner/Banner';
import Pioneer from './Pioneer/Pioneer';
import Evolve from './Evolve/Evolve';
import Header from '../landing/Header/Header';
import Footer from '../landing/footer/Footer';
import Mobilebanner from './Banner/Mobilebanner';
import '../Homepage/Banner/banner.scss'

const Homepage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500); // Adjust delay as needed (500ms)
  
    return () => clearTimeout(timer); // Cleanup to prevent memory leaks
  }, []);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
    <div className="homepagemain">
      <Header />
      {isMobile ? <Mobilebanner /> : <Banner />}
      <Pioneer />
      <Evolve />
      <Footer />
      </div>
    </>
  );
};

export default Homepage;
